@if (isFetching) {
  <div class="itinerary-card">
    <div class="itinerary-card__header">
      <figure>
        <ngx-skeleton-loader [theme]="{height: '100%', width: '100%'}"></ngx-skeleton-loader>
      </figure>
      <div class="itinerary-card__duration">
        ‎
      </div>
    </div>
    <div class="itinerary-card__content">
      <h3 #titleRef>
        ‎<ngx-skeleton-loader [theme]="{height: titleRef.clientHeight + 'px', width: '70%'}"></ngx-skeleton-loader>
      </h3>

      <div class="itinerary-card__row">
        <ngx-skeleton-loader [theme]="{height: '16px', width: '250px'}"></ngx-skeleton-loader>
      </div>
      <div class="itinerary-card__row">
        <ngx-skeleton-loader [theme]="{height: '16px', width: '250px'}"></ngx-skeleton-loader>
      </div>
    </div>
    <div class="itinerary-card__footer">
      <button class="itinerary-card__read-more btn-default btn-blue">
        Explore
      </button>
    </div>
  </div>
} @else {
  @if(itinerary) {
    <div class="itinerary-card" (click)="openTripOverview()">
      <div class="itinerary-card__header">
        <figure>
          <img [src]="itinerary?.image_url | safeUrl" alt="country-image">
        </figure>
        <div class="itinerary-card__duration">
          {{tripRange}} days
        </div>
      </div>
      <div class="itinerary-card__content">
        <h3>{{ itinerary.name }}</h3>

        <div class="itinerary-card__row">
          <p class="itinerary-card__location">
            {{ itinerary?.startCity }} | {{ itinerary?.endCity }}
          </p>
        </div>

        <div class="itinerary-card__row">
          <p class="itinerary-card__description"
             [innerHtml]="itinerary.description"></p>
        </div>
      </div>
      <div class="itinerary-card__footer">
        <button class="itinerary-card__read-more btn-default btn-blue" (click)="openTripOverview()">
          Explore
        </button>
      </div>
    </div>
  }

}
